<template>
  <div class="page-container">
    <v-container>
      <v-row>
        <v-col cols="12">
          <!-- Hero Section -->
          <div class="hero-section mb-6">
            <h1 class="text-h4 font-weight-bold mb-2">
              Herramientas SaaS para desarrolladores 2026
            </h1>
            <p class="text-subtitle-1 grey--text text--darken-1">
              Optimiza tu flujo de trabajo con las mejores herramientas de software como
              servicio.
            </p>
          </div>

          <v-divider class="my-6"></v-divider>

          <!-- Grid de herramientas -->
          <v-row>
            <v-col cols="12" md="6" v-for="(tool, index) in tools" :key="index">
              <v-card class="tool-card" elevation="2" hover>
                <v-card-title class="text-h6 font-weight-medium">
                  <v-icon :color="tool.color" class="mr-2" large>{{ tool.icon }}</v-icon>
                  {{ tool.name }}
                </v-card-title>
                <v-card-text>
                  <p class="mb-2">{{ tool.description }}</p>
                  <v-chip
                    small
                    :color="tool.category === 'IA' ? 'primary' : 'grey lighten-2'"
                    class="mt-1"
                  >
                    {{ tool.category }}
                  </v-chip>
                </v-card-text>
                <v-card-actions>
                  <v-btn text color="primary" :href="tool.url" target="_blank"
                    >Conocer más →</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

          <!-- Sección de consejos -->
          <v-card class="pa-4 mt-6" color="grey lighten-4">
            <h3 class="text-h6 font-weight-medium mb-3">
              🚀 Cómo elegir las herramientas adecuadas
            </h3>
            <p>Antes de invertir en una herramienta SaaS, considera:</p>
            <ul class="ml-4">
              <li>✅ Integración con tu stack tecnológico actual</li>
              <li>✅ Escalabilidad y planes de precios</li>
              <li>✅ Soporte técnico y documentación disponible</li>
              <li>✅ Opiniones de otros desarrolladores</li>
            </ul>
          </v-card>

          <p class="text-caption text-center mt-6 grey--text">
            *Las herramientas listadas son referencias del mercado. Algunos planes
            gratuitos tienen limitaciones.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PaginaSaaSHerramientas",
  data() {
    return {
      tools: [
        {
          name: "GitHub Copilot",
          icon: "mdi-github",
          color: "#181717",
          description:
            "Asistente de código con IA que acelera tu desarrollo y reduce errores.",
          category: "IA",
          url: "https://github.com/features/copilot",
        },
        {
          name: "Notion",
          icon: "mdi-notebook",
          color: "#000000",
          description:
            "Documentación, gestión de proyectos y base de conocimientos todo en uno.",
          category: "Productividad",
          url: "https://notion.so",
        },
        {
          name: "Slack",
          icon: "mdi-slack",
          color: "#4A154B",
          description: "Comunicación en equipo con integraciones para desarrollo.",
          category: "Colaboración",
          url: "https://slack.com",
        },
        {
          name: "Figma",
          icon: "mdi-figma",
          color: "#F24E1E",
          description: "Diseño colaborativo de interfaces y prototipos interactivos.",
          category: "Diseño",
          url: "https://figma.com",
        },
        {
          name: "Linear",
          icon: "mdi-chart-line",
          color: "#5E6AD2",
          description: "Gestión de incidencias y seguimiento de proyectos ágiles.",
          category: "Gestión",
          url: "https://linear.app",
        },
        {
          name: "Vercel",
          icon: "mdi-cloud-upload",
          color: "#000000",
          description: "Despliegue continuo para aplicaciones frontend y serverless.",
          category: "DevOps",
          url: "https://vercel.com",
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px 40px;
}
.hero-section {
  text-align: center;
}
.tool-card {
  border-radius: 16px;
  transition: transform 0.2s ease;
  height: 100%;
}
.tool-card:hover {
  transform: translateY(-4px);
}
</style>
